import { PaymentMethod } from '../domain/types';

export const paymentMethodWizardLabels: {
  [key in PaymentMethod]: string;
} = {
  CHECK: 'Assegno',
  BANK_TRANSFER: 'Bonifico',
};
